import {
  ReactElement,
  RefAttributes,
  forwardRef,
  ForwardedRef,
  ForwardRefRenderFunction,
  PropsWithoutRef,
} from 'react';

import { IFocusableProps, IFocusableAttrs } from './focusable';
import { IChangeableProps } from './changeable';

type IInputAttrs = IFocusableAttrs;

interface IInputProps<
  TName extends string = string,
  TValue = string,
  TFocusableElement extends Element = Element,
>
  extends IFocusableProps<TFocusableElement>, IChangeableProps<TValue, TName> {
  isDisabled?: boolean;
  hasError?: boolean;
  placeholder?: React.ReactNode;
  dataTestId?: string;
}

type Input<
  TName extends string = string,
  TValue = string,
  TFocusableElement extends Element = Element,
> = (
  props: IInputProps<TName, TValue, TFocusableElement> & RefAttributes<IInputAttrs>,
) => ReactElement | null;

const forwardInputRef = <TProps, TAttrs extends IInputAttrs>(
  render: (props: TProps, ref: ForwardedRef<TAttrs>) => ReactElement | null,
): ((props: TProps & RefAttributes<TAttrs>) => ReactElement | null) =>
  forwardRef(render as ForwardRefRenderFunction<TAttrs, PropsWithoutRef<TProps>>) as any;

export { forwardInputRef };
export type { IInputAttrs, IInputProps, Input };
